module.exports = __webpack_public_path__ + "static/praxisTisch-820622d1c58a42a053fe57f38d08fffa.jpg";